export const separator = "\u2009\u2014\u2009";
